import { render, staticRenderFns } from "./DiscountsPage.vue?vue&type=template&id=2a5af552&scoped=true&"
import script from "./DiscountsPage.vue?vue&type=script&lang=js&"
export * from "./DiscountsPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsPage.vue?vue&type=style&index=0&id=2a5af552&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5af552",
  null
  
)

export default component.exports